<template>
  <div class="add-commodity">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toCommodityList">商品列表/</span>
        <span v-if="id">修改商品</span>
        <span v-else>新增商品</span>
      </template>
      <template v-slot:content>
        <div class="add-commodity-main">
          <div class="AddProductContainer">
            <!-- 商品信息 -->
            <div class="information">
              <div class="title" ref="steps">商品信息</div>
              <div class="information-container">
                <el-form
                  label-position="right"
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="110px"
                  class="demo-ruleForm"
                >
                  <div class="flex">
                    <el-form-item label="商品名称：" prop="name" class="w320">
                      <el-input
                        v-model="ruleForm.name"
                        type="textarea"
                        resize="none"
                        autosize
                        placeholder="请输入商品名称"
                        class="gray"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="商品分类："
                      prop="classify"
                      class="w270"
                    >
                      <el-cascader
                        ref="cascader"
                        class="gray"
                        v-model="ruleForm.classify"
                        :options="classify"
                        :props="defaultParams"
                        placeholder="选择分类"
                        filterable
                        @blur="changeClassify"
                      ></el-cascader>
                    </el-form-item>
                  </div>
                  <div class="flex">
                    <el-form-item
                      label="商品副标题："
                      prop="subheading"
                      class="w320"
                    >
                      <el-input
                        v-model="ruleForm.subheading"
                        placeholder="请输入副标题"
                        class="gray"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="商品品牌：" prop="brand" class="w270">
                      <el-select
                        v-model="ruleForm.brand"
                        class="gray"
                        clearable
                        filterable
                        placeholder="请选择品牌"
                      >
                        <el-option
                          v-for="item in brand"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="flex">
                    <el-form-item label="商品编码：" prop="code" class="w320">
                      <el-input
                        v-model="ruleForm.code"
                        placeholder="请输入商品编码"
                        class="gray"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="排序权重：" prop="weight" class="w100">
                      <el-input
                        :disabled="Number(ruleForm.weight) > 1000"
                        v-model.number="ruleForm.weight"
                        placeholder="请输入权重"
                        v-on:blur="math(ruleForm.weight)"
                        class="gray"
                      ></el-input>
                      <div class="weight">请输入1到1000中的数字,数字越大排序越靠前</div>
                    </el-form-item>
                  </div>
                  <div class="flex">
                    <el-form-item label="上架下架：" prop="status">
                      <el-radio v-model="ruleForm.status" :label="1"
                        >上架</el-radio
                      >
                      <el-radio v-model="ruleForm.status" :label="0"
                        >下架</el-radio
                      >
                    </el-form-item>
                    <el-form-item label="商品参数：" class="parameter-item" prop="parameterData">
                      <el-button
                        class="btn-blue"
                        @click="openParameterDialog"
                        v-if="!isSettingParameter"
                        >设置</el-button
                      >
                      <el-button
                        class="btn-blue"
                        @click="openParameterDialog"
                        v-else
                        >已设置</el-button
                      >
                      <!-- 选中参数展示 -->
                      <div class="select-parameter-show" v-if="selectParameterArr.length > 0">
                        <div class="table">
                          <el-table
                            :data="selectParameterArr"
                            style="width: 100%"
                            max-height="185"
                          >
                          <el-table-column
                            prop="name"
                            label="参数名"
                            width="120"
                          ></el-table-column>
                          <el-table-column label="参数值">
                            <template slot-scope="scope">
                              <div
                                class="show-parameter"
                                v-for="(value, index) in scope.row.values"
                                :key="index"
                              >
                                <el-tooltip v-if="strLen(value.value) > 10" :content="value.value" placement="top">
                                  <p class="tips">{{ value.value }}</p>
                                </el-tooltip>
                                <p v-else>{{ value.value }}</p>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>

                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="flex">
                    <el-form-item label="商品标签：" prop="label" class="labels" :class="labels.length > 5?'active':''">
                      <div class="labels-containor">
                        <el-checkbox-group v-model="ruleForm.label">
                          <el-checkbox
                            :label="value.id"
                            v-for="(value, index) in labels"
                            :key="index"
                            >{{ value.labelName }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                    </el-form-item>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                    <el-form-item></el-form-item>
                  </div>
                  <el-form-item label="商品图片：" prop="images" class="images dropImg">
                    <el-upload
                      ref="upload"
                      action="#"
                      class="w50"
                      :class="ruleForm.images.length < 6 ?'':'none'"
                      list-type="picture-card"
                      :limit="6"
                      multiple
                      :on-exceed="handleLimit"
                      :on-remove="onRemove"
                      :before-upload="beforeUpload"
                      :auto-upload="true"
                      :file-list="fileList"
                    >
                      <el-button
                        v-loading="loading"
                        element-loading-text="图片上传中..."
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        slot="trigger"
                        size="small"
                        type="primary"
                      >
                        <i class="add">＋</i>
                        <span class="max">最多6张</span>
                      </el-button>
                      <div
                        slot="tip"
                        class="el-upload__tip"
                      >只能上传JPG/JPEG/BMP/PNG格式文件，且不超过2M，建议尺寸640×640像素</div>
                    </el-upload>
                  </el-form-item>
                    <el-form-item v-if="id" label="销售授权：" prop="saleImage" class="images">
                      <p v-if="!ruleForm.saleImage[0]">暂无图片</p>
                      <el-upload
                        v-else
                        ref="upload"
                        action="#"
                        :class="ruleForm.saleImage.length < 1 ? '' : 'none'"
                        list-type="picture-card"
                        :limit="1"
                        :on-exceed="handSaleleLimit"
                        :on-remove="onSaleRemove"
                        :before-upload="beforeSaleUpload"
                        :auto-upload="true"
                        :file-list="saleFileList"
                      >
                        <div slot="file" slot-scope="{file}">
                          <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-preview"
                              @click="handlePictureCardPreview(file)"
                            >
                              <i class="el-icon-zoom-in"></i>
                            </span>
                          </span>
                        </div>
                        <el-button
                          v-loading="saleLoading"
                          element-loading-text="图片上传中..."
                          element-loading-spinner="el-icon-loading"
                          element-loading-background="rgba(0, 0, 0, 0.8)"
                          slot="trigger"
                          size="small"
                          type="primary"
                        >
                          <i class="add">＋</i>
                          <span class="max">最多1张</span>
                        </el-button>
                        <div slot="tip" class="el-upload__tip">只能上传JPG/JPEG/BMP/PNG格式文件，且不超过2M</div>
                      </el-upload>
                    </el-form-item>
                </el-form>

                
              </div>
            </div>
            <!-- 库存/规格 -->
            <div class="specification-inventory">
              <div class="title">库存/规格</div>
              <div class="specification-setting">
                <div class="specification-title">规格设置：</div>
                <!-- 右侧部分 -->
                <div class="add-specification">
                  <div
                    class="specification-list"
                    v-for="(value, index) in specification"
                    :key="index"
                  >
                    <div class="select">
                      <el-select
                        v-model="specification[index].title"
                        filterable
                        allow-create
                        default-first-option
                        placeholder="请选择"
                        @visible-change="
                          changeValue1($event, specification[index].title)
                        "
                        @change="changeSelect(index)"
                      >
                        <el-option
                          v-for="item in specificationList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.value"
                          :disabled="
                            title.indexOf(item.label) != -1 ? true : false
                          "
                        >
                          <span style="float: left">{{ item.label }}</span>
                          <p
                            class="remove"
                            v-if="title.indexOf(item.label) === -1"
                            @click.stop="removeSpecifications(item.id)"
                          >×</p>
                        </el-option>
                      </el-select>
                      <i class="remove" @click="remove(index)"></i>
                    </div>
                    <div class="label">
                      <el-tag
                        :title="tag"
                        :key="tag"
                        v-for="tag in specification[index].dynamicTags"
                        closable
                        :disable-transitions="true"
                        @close="handleClose(tag, index)"
                        >{{ tag }}</el-tag
                      >
                      <el-select
                        v-if="specification[index].inputVisible"
                        v-model="specification[index].inputValue"
                        filterable
                        clearable
                        allow-create
                        default-first-option
                        ref="saveTagInput"
                        @visible-change="
                          handleInputConfirm(
                            $event,
                            specification[index].inputValue,
                            index,
                            specification[index].title
                          )
                        "
                      >
                        <el-option
                          v-for="item in specificationList.filter(function (
                            item
                          ) {
                            return item.value == specification[index].title;
                          })[0].labels"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                          <span style="float: left">{{ item.label }}</span>
                          <p
                            class="remove"
                            @click.stop="
                              removeSpecificationsOption(
                                item.id,
                                specification[index].title
                              )
                            "
                          >
                            ×
                          </p>
                        </el-option>
                      </el-select>
                      <!-- 添加标签 -->
                      <el-button
                        type="text"
                        v-else
                        class="button-new-tag"
                        size="small"
                        @click="showInput(index)"
                        >+ 添加</el-button
                      >
                    </div>
                  </div>
                  <!-- 添加规格按钮 -->
                  <div class="add">
                    <el-button
                      :class="
                        specification.length < 3
                          ? 'add-button'
                          : 'add-button ECEEF5'
                      "
                      :disabled="specification.length == 3 ? true : false"
                      @click="addSpecification"
                      >添加规格</el-button
                    >
                  </div>
                </div>
              </div>
              <div
                class="price-switch"
                v-if="
                  operationList.indexOf(operationsBtns.roleCustomerLevel) !== -1
                "
              >
                <el-switch
                  v-model="priceSwitch"
                  active-color="#409EFF"
                  inactive-color="#DCDFE6"
                ></el-switch>
                <span class="text">
                  开启等级价
                  <el-tooltip
                    effect="dark"
                    placement="top">
                    <div slot="content">
                      开启后，客户展示价格=<br/>
                      市场价+增量数值（可为负数）<br/>
                    </div>
                    <img src="../../../../assets/commodity/tips.png">
                  </el-tooltip>
                </span>
                <!-- <span class="text">开启等级价和指定价</span> -->
                <span class="market-price">
                  <el-checkbox
                    v-model="isAnchoring"
                    @change="changeAnchoring"
                  ></el-checkbox>
                  <el-input
                    v-if="isAnchoring"
                    class="gray w60"
                    v-model="marketPriceAnchor"
                    @input="onInputMarketPriceAnchor(marketPriceAnchor)"
                    placeholder="请输入数值"
                  ></el-input>
                  <span class="text">
                    市场价锚定
                    <el-tooltip
                      effect="dark"
                      placement="top">
                      <div slot="content">
                        开启锚定后，输入增量值<br/>
                        市场价将随成本价变动<br/>
                      </div>
                      <img src="../../../../assets/commodity/tips.png">
                    </el-tooltip>
                  </span>
                </span>
              </div>
              <div class="specification-message">
                <div class="specification-title">规格信息：</div>
                <div class="table">
                  <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    :span-method="objectSpanMethod"
                    v-if="Object.keys(tableData[0]).length > 5"
                  >
                    <template v-for="(value, index) in specification">
                      <el-table-column
                        :key="index"
                        v-if="specification[index].dynamicTags.length > 0"
                        :prop="specification[index].title"
                        :label="specification[index].title"
                      >
                        <template
                          slot-scope="scope"
                          v-if="specification[index].dynamicTags.length > 0"
                        >
                          <span
                            class="text"
                            :title="scope.row[specification[index].title]"
                            >{{ scope.row[specification[index].title] }}</span
                          >
                        </template>
                      </el-table-column>
                    </template>
                    <el-table-column label="SKU编码" prop="erpId">
                      <template slot-scope="scope">
                        <el-input
                          class="gray"
                          v-model="scope.row.erpId"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="retail_price" :label="popover1Title">
                      <template slot-scope="scope">
                        <el-input
                          :disabled='isAnchoring'
                          v-model="scope.row.retail_price"
                          class="gray"
                          @input="
                            onInputRetailPrice(
                              scope.$index,
                              scope.row.retail_price
                            )
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="cost_price" :label="popover2Title">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.cost_price"
                          class="gray"
                          @input="
                            onInputCostPrice(scope.$index, scope.row.cost_price)
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="tourist_price" :label="popover3Title" v-if="isTouristPrice">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.tourist_price"
                          class="gray"
                          @input="
                            onInputTouristPrice(scope.$index, scope.row.tourist_price)
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="等级价"
                      v-if="
                        operationList.indexOf(
                          operationsBtns.roleCustomerLevel
                        ) !== -1 && priceSwitch
                      "
                    >
                      <template slot-scope="scope">
                        <el-button
                          class="btn-text"
                          type="text"
                          @click="setGradePrice(scope.$index, scope.row)"
                        >
                          <span v-if="scope.row.levelPriceStatus === 0"
                            >未设置</span
                          >
                          <span v-if="scope.row.levelPriceStatus === 1"
                            >已设置</span
                          >
                        </el-button>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column
                      label="指定价"
                      v-if="
                        operationList.indexOf(
                          operationsBtns.roleCustomerLevel
                        ) !== -1 && priceSwitch
                      "
                    >
                      <template slot-scope="scope">
                        <el-button
                          class="btn-text"
                          type="text"
                          @click="setDesignatedPrice(scope.$index, scope.row)"
                        >
                          <span v-if="scope.row.cusPriceStatus === 0"
                            >未设置</span
                          >
                          <span v-if="scope.row.cusPriceStatus === 1"
                            >已设置</span
                          >
                        </el-button>
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      v-if="showStock"
                      prop="stock"
                      label="可售库存"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.sale_num"
                          class="gray"
                          @input="
                            onInputSaleNum(scope.$index, scope.row.sale_num)
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="handleDelete(scope.$index, scope.row)"
                          >清空</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="handle">
                    <p class="handle-p">批量处理:</p>
                    <ul class="handle-ul">
                      <li>
                        <el-popover
                          ref="popover1"
                          placement="top"
                          :title="popover1Title"
                          width="250"
                          trigger="click"
                          v-model="retail_price.visible"
                          class="popover"
                        >
                          <el-input
                            :disabled='isAnchoring'
                            @input="retailPrice(retail_price.retail_price)"
                            v-model="retail_price.retail_price"
                          ></el-input>
                          <div style="text-align: right; margin-top: 18px">
                            <el-button
                              size="mini"
                              type="text"
                              @click="cancalRetail_price"
                              >取消</el-button
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              :disabled='isAnchoring'
                              @click="
                                changeRetail_price(retail_price.retail_price)
                              "
                              >确定</el-button
                            >
                          </div>
                        </el-popover>
                        <el-button type="text" v-popover:popover1>{{popover1Title}}</el-button>
                      </li>
                      <li>
                        <el-popover
                          ref="popover2"
                          placement="top"
                          :title="popover2Title"
                          width="250"
                          trigger="click"
                          v-model="cost_price.visible"
                          class="popover"
                        >
                          <el-input
                            @input="costPrice(cost_price.cost_price)"
                            v-model="cost_price.cost_price"
                          ></el-input>
                          <div
                            style="
                              text-align: right;
                              margin-top: 18px;
                              height: 32px;
                            "
                          >
                            <el-button
                              size="mini"
                              type="text"
                              @click="cancalCost_price"
                              >取消</el-button
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              @click="changeCost_price(cost_price.cost_price)"
                              >确定</el-button
                            >
                          </div>
                        </el-popover>
                        <el-button type="text" v-popover:popover2>{{popover2Title}}</el-button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- 商品详情 -->
            <div class="product-details">
              <div class="title">商品详情</div>
              <div class="editor-container dropImgToEditor" ref="editor">
                <editor :catchData="catchData" :content="content"></editor>
              </div>
            </div>
            <!-- 物流/其他 -->
            <div class="logistics-other">
              <div class="title">物流/其他</div>
              <div class="logistics-other-container">
                <el-form
                  :model="ruleForm2"
                  ref="ruleForm2"
                  :rules="rules"
                  label-width="100px"
                  class="demo-ruleForm"
                >
                  <el-form-item label="规格信息：" prop="resource">
                    <el-radio-group v-model="ruleForm2.resource" fill="#000000">
                      <el-radio :label="true">
                        <span>统一运费</span>
                        <el-input
                          class="elInput"
                          placeholder="0.00"
                          v-model="ruleForm2.uniformFreight"
                          @input="carriage(ruleForm2.uniformFreight)"
                        ></el-input>
                        <span>元</span>
                      </el-radio>
                      <br />
                      <el-radio :label="false">
                        <el-select
                          v-model="ruleForm2.freightId"
                          placeholder="选择运费模板"
                        >
                          <el-option
                            v-for="item in freight"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <el-button
                          v-if="
                            operationList.indexOf(
                              operationsBtns.roleGoodsTraffic
                            ) !== -1
                          "
                          type="text"
                          @click="addTemplate"
                          >添加模板</el-button
                        >
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="operations" ref="operations">
              <el-button class="btn-white" @click="cancal">返回</el-button>
              <el-button
                class="btn-blue"
                :disabled="isFinishDataLoading"
                @click="submit('ruleForm', 'ruleForm2')"
                >保存</el-button
              >
              <el-button
                class="btn-blue"
                v-if="id"
                @click="toPreviewProduct(id)"
                >预览</el-button
              >
            </div>
            <!-- 等级价格弹窗 -->
            <el-dialog
              title="等级价"
              :visible.sync="dialogGradePriceVisible"
              width="520px"
              top="25vh"
            >
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <p class="text">
                <span>根据不同客户等级定价</span>
                <el-button class="btn-blue" @click="resetGradePrice"
                  >重置</el-button
                >
              </p>
              <div class="table">
                <el-table :data="gradePriceTable" style="width: 100%">
                  <el-table-column
                    prop="name"
                    label="客户等级"
                  ></el-table-column>
                  <!-- <el-table-column label="等级折扣">
                    <template slot-scope="scope">
                      <span>{{ scope.row.rebate }}</span>
                      <span>%</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column label="价格增量">
                    <template slot-scope="scope">
                      <el-input
                        @input="
                          onInputGradePrice(scope.$index, scope.row.gradePrice)
                        "
                        class="gray h24"
                        @change="changeGradePrice(scope.$index, scope.row.gradePrice)"
                        v-model="scope.row.gradePrice"
                      ></el-input>
                      <span class="gradePrice" v-if="scope.row.isGradePrice === 0">等级价必须大于0</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="dialog-footer-btn">
                <el-button class="btn-white" @click="cancelGradePrice"
                  >取消</el-button
                >
                <el-button class="btn-blue" @click="saveGradePrice"
                  >保存</el-button
                >
              </div>
            </el-dialog>
            <!-- 参数弹窗 -->
            <el-dialog
              title="参数设置"
              :visible.sync="dialogParameterVisible"
              width="800px"
              top="10vh"
            >
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <div class="dialog-parameter-main">
                <div class="dialog-parameter-left">
                  <div class="top-search">
                    <el-input
                      class="white w320"
                      placeholder="请输入参数组名"
                      @keyup.enter.native="searchParameterGroup"
                      v-model="parameterNameGroupSearch"
                    >
                      <i slot="suffix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </div>
                  <div class="parameter-group">
                    <div
                      v-for="(item, index) in parameterGroupList"
                      :key="index"
                      :class="
                        activeMoveParameterNameIndex === index
                          ? 'parameter-group-active parameter-group-row'
                          : 'parameter-group-row'
                      "
                      @click="moveParameterNameselecd(index, item.id)"
                    >
                      {{ `${item.name}(${item.nums})` }}
                    </div>
                  </div>
                </div>
                <div class="dialog-parameter-right">
                  <div class="dialog-parameter-search">
                    <el-input
                      class="gray dialog-parameter-input"
                      placeholder="请输入参数名"
                      prefix-icon="el-icon-search"
                      clearable
                      @keyup.enter.native="searchParameter"
                      v-model="parameterName"
                    ></el-input>
                  </div>
                  <p class="select-parameter">已选中参数</p>
                  <div class="select-row">
                    <div class="select-item" v-for="(item, index) in selectParameterList" :key="index">
                      <span class="parameter-name">{{item.value}}</span>
                      <span class="delete-parameter" @click="deleteParameter(item.id, index)">
                        <i class="el-icon-circle-close"></i>
                      </span>
                    </div>
                  </div>
                  <div class="dialog-parameter-table">
                    <div class="table">
                      <el-table
                        :data="parameterTable"
                        style="width: 100%"
                        max-height="400"
                      >
                        <el-table-column
                          prop="parameterName"
                          label="参数名"
                          width="120"
                        ></el-table-column>
                        <el-table-column label="参数值">
                          <template slot-scope="scope">
                            <el-checkbox-group v-model="parameterCheckedData" @change="handleCheckedCitiesChange">
                              <el-checkbox
                                v-for="(value, index) in scope.row.parameterValue"
                                :label="value.id+':'+ value.value"
                                :key="index"
                                >
                                <el-tooltip v-if="strLen(value.value) > 10" :content="value.value" placement="top">
                                  <p class="tips">{{ value.value }}</p>
                                </el-tooltip>
                                <p v-else>{{ value.value }}</p>
                              </el-checkbox
                              >
                            </el-checkbox-group>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div class="page">
                        <pagination-tpl
                          :pageSize="pageSize"
                          :total="total"
                          :currentPage="page"
                          @queryChange="updatePage"
                        ></pagination-tpl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dialog-footer-btn">
                <el-button
                  class="btn-white"
                  @click="dialogParameterVisible = false"
                  >取消</el-button
                >
                <el-button class="btn-blue" @click="saveParameter"
                  >保存</el-button
                >
              </div>
            </el-dialog>
            <!-- 指定价弹窗 -->
            <el-dialog
              title="指定价"
              :visible.sync="dialogDesignatedPriceVisible"
              width="720px"
              top="13vh"
            >
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <p class="add-client">
                <span>请选择客户：</span>
                <el-button class="btn-blue" @click="openClientListDialog"
                  >选择客户</el-button
                >
              </p>
              <div class="table">
                <el-table :data="clientTable" style="width: 100%" height="350">
                  <el-table-column
                    prop="xbName"
                    label="客户名称"
                  ></el-table-column>
                  <el-table-column prop="itemPrice" label="价格" width="200">
                    <template slot-scope="scope">
                      <el-input
                        class="gray"
                        @input="
                          onInputDesignatedPrice(
                            scope.$index,
                            scope.row.itemPrice
                          )
                        "
                        v-model="scope.row.itemPrice"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button
                        class="btn-text"
                        type="text"
                        @click="deleteSelectclient(scope.$index)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="dialog-footer-btn">
                <el-button
                  class="btn-white"
                  @click="closeDesignatedPriceVisible"
                  >取消</el-button
                >
                <el-button class="btn-blue" @click="saveDesignatedPrice"
                  >保存</el-button
                >
              </div>
            </el-dialog>
            <!-- 客户弹窗 -->
            <el-dialog
              class="add-customer-container"
              :close-on-click-modal="false"
              :visible.sync="isShowClientListDialog"
              width="650px"
              top="20vh"
            >
              <span slot="title">选择客户</span>
              <div class="content">
                <div class="search-key-tag">
                  <div class="search-key">
                    <el-input
                      v-model="clientForm.key"
                      @keyup.enter.native="searchClient()"
                      class="gray"
                      placeholder="请输入客户名称或手机号"
                    ></el-input>
                  </div>
                  <div class="search-tag">
                    <el-select
                      class="gray"
                      v-model="clientForm.tagId"
                      placeholder="请选择客户标签"
                      clearable
                    >
                      <el-option
                        v-for="item in tagList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <el-button class="btn-blue" @click="searchClient()"
                    >搜索</el-button
                  >
                </div>
                <!-- 客户列表 -->
                <div class="clientList table">
                  <el-table
                    ref="multipleTable"
                    class="table-container"
                    :data="clientList"
                    height="250"
                    @selection-change="handleSelectionClient"
                  >
                    <el-table-column
                      type="selection"
                      width="55"
                    ></el-table-column>
                    <el-table-column
                      label="客户名称"
                      prop="name"
                    ></el-table-column>
                    <el-table-column
                      label="联系人"
                      prop="contact"
                      width="120px"
                    ></el-table-column>
                    <el-table-column
                      label="手机号"
                      prop="telephone"
                      width="125px"
                    ></el-table-column>
                    <el-table-column label="账号状态" width="100px">
                      <template slot-scope="props">
                        <div class="status-desc-container">
                          <span
                            class="status-desc"
                            v-show="props.row.status === 0"
                            >未审核</span
                          >
                          <span
                            class="status-desc"
                            v-show="props.row.status === 1"
                            >已启用</span
                          >
                          <span
                            class="status-desc"
                            v-show="props.row.status === 2"
                            >已禁用</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pagination-container">
                    <pagination-tpl
                      :total="customerTotalNum"
                      @queryChange="customerUpdatePage"
                      :currentPage="customerCurrentPage"
                    ></pagination-tpl>
                  </div>
                </div>
                <div class="dialog-footer-btn">
                  <el-button class="btn-white" @click="closeClientList"
                    >取消</el-button
                  >
                  <el-button class="btn-blue" @click="saveSelectClient"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-dialog>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import Sortable from 'sortablejs';
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import Editor from "base/Editor";
import {
  getDBOperationPermission,
  getDBModuleStatusPermission,
} from "common/js/storage"; // 权限数据接口
import DBCommodity from "models/db/commodity.js";
import ImgUploader from "models/img-upload.js";
import DBClient from "models/db/client.js";
import DBSiteSet from "models/db/site-set.js";
const dbSiteSet = new DBSiteSet();
const dbCommodity = new DBCommodity();
const imgUploader = new ImgUploader();
const dbClient = new DBClient();
export default {
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮--添加运费模板,等级价
      operationsBtns: {
        roleGoodsTraffic: "ROLE_GOODS_traffic",
        roleCustomerLevel: "ROLE_CUSTOMER_level",
      },
      // 数据回填时当前页的id
      id: "",
      content: "", // 富文本编辑器传入内容
      // 商品信息form表单
      ruleForm: {
        name: "", // 名称
        subheading: "", // 副标题
        code: "", // 编码
        images: [], // 图片
        saleImage: [], // 图片
        classify: "", // 分类
        brand: "", // 品牌
        weight: 500, // 权重
        status: 1, // 上架下架
        parameterData: [], // 选取的参数
        label: [], // 标签
        content: "", // 返回富文本内容
      },
      // 底部商品表单
      ruleForm2: {
        resource: true, // 是否统一
        uniformFreight: 0.0, // 运费
        freightId: "", // 运费模板
      },
      rules: {
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        weight: [{ required: true, message: "请输入权重", trigger: "blur" }],
        images: [
          { required: true, message: "请上传商品图片", trigger: "blur" },
        ],
        classify: [
          { required: true, message: "请选择商品分类", trigger: "change" },
        ],
        resource: [
          { required: true, message: "请选择运费", trigger: "change" },
        ],
      },
      classify: [], // 分类数据存储
      brand: [], // 品牌数据存储
      defaultParams: {
        label: "cateName",
        value: "id",
        children: "children",
      },
      isAnchoring: null,        // 是否开启锚定
      marketPriceAnchor: '', //市场价锚定
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [], // 上传图片的中间过渡图片数据
      saleFileList: [], // 上传销售授权图片的中间过渡图片数据
      file: "", // 单个图片上传
      saleFile: "", // 单个图片上传
      loading: false, // loading开关控制
      saleLoading: false, // loading开关控制
      labels: [], // 商品标签数据
      specification: [
        // {
        //   title: '',
        //   dynamicTags: [],
        //   inputVisible: false,
        //   inputValue: ''
        // }
      ], // 规格以及表单生成数据
      specificationList: [
        // {
        //   value: 'HTML',
        //   label: 'HTML',
        //   labels: [
        //     {
        //       value: '222',
        //       label: '222'
        //     }
        //   ]
        // }
      ], // 规格列表选择数据
      title: [], // 选中的规格不可再选
      // table数据
      tableData: [
        {
          erpId: null,
          retail_price: null,
          cost_price: null,
          tourist_price: null,
          sale_num: null,
          levelPriceStatus: 0, // 等级价格状态
          itemLevelPriceList: [], // 等级价格数据
          cusPriceStatus: 0, // 指定价价格状态
          itemCusPriceList: [], // 指定价价格数据
        },
      ],
      freight: [], // 运费模板数据
      retail_price: {
        retail_price: null,
        visible: false,
      }, // 市场价
      cost_price: {
        cost_price: null,
        visible: false,
      }, // 成本价
      items: [], // sku回填数据
      showStock: false, // 库存会否开启
      priceSwitch: true, // 开启等级价和指定价是否开启
      isTouristPrice: false,  //游客价是否开启
      dialogGradePriceVisible: false, // 等级价弹窗
      gradePriceTable: [], // 等级价数据
      priceItemsIndex: "", // 选取的item下标
      dialogParameterVisible: false, // 参数弹窗
      parameterName: "", //参数名
      searchParameterName: "", //参数搜索值
      parameterTable: [], // 参数数据
      parameterCheckedData: [], // 选取的参数
      isSettingParameter: false,
      pageSize: 0, //参数翻页
      total: 0,
      page: 1,
      dialogDesignatedPriceVisible: false, //指定价弹窗
      clientTable: [], //指定价选择的客户数据
      isShowClientListDialog: false, //客户弹窗
      clientForm: {
        key: "",
        tagId: "",
      },
      searchClientForm: {
        key: "",
        tagId: "",
      },
      tagList: [], //客户标签列表
      clientList: [], //客户列表
      selectionClient: [], //选择的客户
      customerTotalNum: 0,
      customerCurrentPage: 1,
      popover1Title: '市场价',
      popover2Title: '成本价',
      popover3Title: '游客价增量',
      parameterGroupList: [],
      activeMoveParameterNameIndex: 0,
      groupId: null,         //参数组id
      selectParameterList: [],
      parameterNameGroupSearch: '',
      // 选中的参数
      selectParameterArr: [],
      isFinishDataLoading: false, // 详情数据是否加载完成
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
    Editor,
  },
  watch: {
    // 监听商品标签（最多只能选择一个）
    "ruleForm.label": {
      handler(newName, oldName) {
        if (newName.length === 4) {
          this.ruleForm.label.splice(0, 1);
        }
      },
      deep: true,
    },
    specification: {
      handler(newName, oldName) {
        if (this.specification.length === 0) {
          this.title = [];
          this.tableData = [
            {
              erpId: null,
              retail_price: null,
              cost_price: null,
              tourist_price: null,
              sale_num: null,
              levelPriceStatus: 0, // 等级价格状态
              itemLevelPriceList: [], // 等级价格数据
              cusPriceStatus: 0, // 指定价价格状态
              itemCusPriceList: [], // 指定价价格数据
            },
          ];
        } else if (
          this.specification.length === 1 ||
          this.specification[1].dynamicTags.length === 0
        ) {
          let arr = [];
          this.title = [this.specification[0].title];
          for (
            let i = 0;
            i <= this.specification[0].dynamicTags.length - 1;
            i++
          ) {
            let obj = {};
            let value1 = this.specification[0].title;
            obj[value1] = this.specification[0].dynamicTags[i];
            obj.erpId = null;
            obj.retail_price = null;
            obj.cost_price = null;
            obj.tourist_price = null;
            obj.sale_num = null;
            obj.levelPriceStatus = 0;
            obj.itemLevelPriceList = [];
            obj.cusPriceStatus = 0;
            obj.itemCusPriceList = [];
            arr.push(obj);
          }
          if (arr.length > 0) {
            this.tableData = arr;
          } else {
            this.tableData = [
              {
                erpId: null,
                retail_price: null,
                cost_price: null,
                tourist_price: null,
                sale_num: null,
                levelPriceStatus: 0,
                itemLevelPriceList: [],
                cusPriceStatus: 0,
                itemCusPriceList: [],
              },
            ];
          }
        } else if (
          this.specification.length === 2 ||
          this.specification[2].dynamicTags.length === 0
        ) {
          let arr = [];
          this.title = [
            this.specification[0].title,
            this.specification[1].title,
          ];
          for (
            let i = 0;
            i <= this.specification[0].dynamicTags.length - 1;
            i++
          ) {
            for (
              let j = 0;
              j <= this.specification[1].dynamicTags.length - 1;
              j++
            ) {
              let obj = {};
              let value1 = this.specification[0].title;
              let value2 = this.specification[1].title;
              obj[value1] = this.specification[0].dynamicTags[i];
              obj[value2] = this.specification[1].dynamicTags[j];
              obj.erpId = null;
              obj.retail_price = null;
              obj.cost_price = null;
              obj.tourist_price = null;
              obj.sale_num = null;
              obj.levelPriceStatus = 0;
              obj.itemLevelPriceList = [];
              obj.cusPriceStatus = 0;
              obj.itemCusPriceList = [];
              arr.push(obj);
            }
          }
          if (arr.length > 0) {
            this.tableData = arr;
          }
        } else if (
          this.specification.length === 3 ||
          this.specification[2].dynamicTags.length !== 0
        ) {
          let arr = [];
          this.title = [
            this.specification[0].title,
            this.specification[1].title,
            this.specification[2].title,
          ];
          for (
            let i = 0;
            i <= this.specification[0].dynamicTags.length - 1;
            i++
          ) {
            for (
              let j = 0;
              j <= this.specification[1].dynamicTags.length - 1;
              j++
            ) {
              for (
                let k = 0;
                k <= this.specification[2].dynamicTags.length - 1;
                k++
              ) {
                let obj = {};
                let value1 = this.specification[0].title;
                let value2 = this.specification[1].title;
                let value3 = this.specification[2].title;
                obj[value1] = this.specification[0].dynamicTags[i];
                obj[value2] = this.specification[1].dynamicTags[j];
                obj[value3] = this.specification[2].dynamicTags[k];
                obj.erpId = null;
                obj.retail_price = null;
                obj.cost_price = null;
                obj.tourist_price = null;
                obj.sale_num = null;
                obj.levelPriceStatus = 0;
                obj.itemLevelPriceList = [];
                obj.cusPriceStatus = 0;
                obj.itemCusPriceList = [];
                arr.push(obj);
              }
            }
          }
          if (arr.length > 0) {
            this.tableData = arr;
          }
        }
        if (this.items.length > 0) {
          this.tableData.map((value, index, array) => {
            let obj = {};
            for (let i = 0; i < this.specification.length; i++) {
              obj[this.specification[i].title] =
                value[this.specification[i].title];
            }
            let objString = JSON.stringify(obj);
            this.items.map((v, i) => {
              let objSpecInfo = {};
              for (let i = 0; i < this.specification.length; i++) {
                objSpecInfo[this.specification[i].title] =
                  v.specInfo[this.specification[i].title];
              }
              if (objString === JSON.stringify(objSpecInfo)) {
                this.$set(this.tableData[index], "erpId", v.erpId);
                this.$set(this.tableData[index], "retail_price", v.marketPrice);
                this.$set(this.tableData[index], "cost_price", v.basePrice);
                this.$set(this.tableData[index], "tourist_price", v.visitorIncrement);
                this.$set(this.tableData[index], "sale_num", v.saleNum);
                this.$set(
                  this.tableData[index],
                  "levelPriceStatus",
                  v.levelPriceStatus
                );
                this.$set(
                  this.tableData[index],
                  "itemLevelPriceList",
                  v.itemLevelPriceList
                );
                this.$set(
                  this.tableData[index],
                  "cusPriceStatus",
                  v.cusPriceStatus
                );
                this.$set(
                  this.tableData[index],
                  "itemCusPriceList",
                  v.itemCusPriceList
                );
                this.$set(this.tableData[index], "skuId", v.id);
              }
            });
          });
        }
        // console.log(this.title);
      },
      deep: true,
    },
    freight: {
      handler(newVal, oldVal) {
        // 判断默认物流模板
        // console.log(newVal);
        if (!this.ruleForm2.freightId && newVal.length > 0) {
          this.ruleForm2.freightId = newVal[0].id;
        }
      },
      deep: true,
    },
  },
  created() {
    if (window.location.host == 'www.it-nd.com') {
      this.rules.parameterData = [{ required: true, message: "请设置商品参数", trigger: "change" }]
    }
    if(window.location.hostname == 'yxp.best1.com') {
      this.popover1Title = '核定直播价'
      this.popover2Title = '直播价'
    }
    this.operationList = getDBOperationPermission();
    this.showStock = getDBModuleStatusPermission().moduleStorage !== 1;
    this.isTouristPrice = getDBModuleStatusPermission().moduleVisitorIncrement === 1;
    this.id = this.$route.query.id ? this.$route.query.id : "";
    this.getGoodsClassify(); // 获取商品分类
    this.getLabel(); // 获取商品标签
    this.getBrand(); // 获取商品仓库
    this.getSpecification(); // 获取商品规格
    this.getFreight(); // 获取运费模板
    this.$nextTick(() => {
      this.getData(); // 获取详情数据
    })
    this.getGradePrice(); // 等价列表
    this.getParameterData(); //参数数据
    // this.getClientTagList();
    // this.getClientList();
    this.initParameterGroupList()
  },
  mounted() {
    this.drag()
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth + "px";
    this.$refs.editor.style.width = this.$refs.steps.clientWidth + "px";
    window.onresize = () => {
      this.$refs.editor.style.width = this.$refs.steps.clientWidth + "px";
      this.$refs.operations.style.width =
        this.$refs.steps.clientWidth + paddingWidth + "px";
    };
  },
  methods: {
    // 商品图片拖拽
    drag() {
      const el = document.querySelector(
        ".dropImg > .el-form-item__content > div > .el-upload-list"
      );
      const _this = this;
      Sortable.create(el, {
        group: {
          name: 'shared',
          pull: 'clone' // To clone: set pull to 'clone'
        },
        disabled: false, // 拖拽不可用? false 启用
        ghostClass: 'sortable-ghost', //拖拽样式
        animation: 150, // 拖拽延时，效果更好看
        onEnd: (e) => { // 拖拽结束时的触发
          const eitorELement = document.querySelector(
            ".dropImgToEditor > #wangeditor > div > .w-e-text-container > .w-e-text"
          );
          if (this.checkIn(eitorELement)) {
            let drayImgCloneToEditor = document.querySelector(
              ".dropImgToEditor > #wangeditor > div > .w-e-text-container > .w-e-text > p"
            );
            
            drayImgCloneToEditor.appendChild(e.clone.childNodes[0])
            drayImgCloneToEditor.click()
          }
          
          let arr = _this.ruleForm.images; // 获取表数据
          let arrCopy = _this.fileList
          arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
          arrCopy.splice(e.newIndex, 0, arrCopy.splice(e.oldIndex, 1)[0])
          _this.fileList = arrCopy
          _this.ruleForm.images= arr;
        },
      })
    },
    // 判断鼠标是否落在一个块级元素内部obj是被拖拽的元素
    checkIn(obj) {
      let x = Number(window.event.clientX) // 鼠标相对屏幕横坐标
      let y = Number(window.event.clientY) // 鼠标相对屏幕纵坐标

      let div_x = Number(obj.getBoundingClientRect().left) // obj相对屏幕的横坐标
      let div_x_width = Number(
          obj.getBoundingClientRect().left + obj.clientWidth
      ) // obj相对屏幕的横坐标+width

      let div_y = Number(obj.getBoundingClientRect().top) // obj相对屏幕的纵坐标
      let div_y_height = Number(
          obj.getBoundingClientRect().top + obj.clientHeight
      ) // obj相对屏幕的纵坐标+height

      if (x > div_x && x < div_x_width && y > div_y && y < div_y_height) {
          return true
      } else {
          return false
      }
    },
    /* 获得字符串实际长度，中文2，英文1 */
    strLen(str) {
      let realLength = 0, len = str.length, charCode = -1;  
      for (let i = 0; i < len; i++) {  
          charCode = str.charCodeAt(i);  
          if (charCode >= 0 && charCode <= 128) realLength += 1;  
          else realLength += 2;  
      }  
      return realLength;   
    },
    // 返回上一层
    toCommodityList() {
      this.$router.push("commodity-list");
    },
    changeAnchoring() {
      if (this.isAnchoring) {
        this.tableData.map(i => {
          i.retail_price = Number(i.cost_price) + Number(this.marketPriceAnchor)
        })
        this.$set(this.tableData, "retail_price", RetailPrice);
      }
    },
    // 限制锚定增量价格输入
    onInputMarketPriceAnchor(price) {
      if (price == '.') {
        price = ''
      }
      let anchorPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.marketPriceAnchor = anchorPrice
      if (this.isAnchoring) {
        this.tableData.map(i => {
          i.retail_price = Number(i.cost_price) + Number(anchorPrice)
        })
        this.$set(this.tableData, "retail_price", RetailPrice);
      }
    },
    // 限制市场价格的输入
    onInputRetailPrice(index, price) {
      // 通过正则过滤小数点后两位
      // let RetailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)[0] || null;
      if (price == '.') {
        price = ''
      }
      let RetailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.tableData[index], "retail_price", RetailPrice);
    },
    // 限制成本价格的输入
    onInputCostPrice(index, price) {
      // console.log(price.toString().match(/^\d*(\.?\d{0,2})/g));
      // let CostPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)[0] || null;
      if (price == '.') {
        price = ''
      }
      let CostPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      if (this.isAnchoring) {
        let RetailPrice = Number(CostPrice) + Number(this.marketPriceAnchor)
        this.$set(this.tableData[index], "retail_price", RetailPrice);
      }
      this.$set(this.tableData[index], "cost_price", CostPrice);
    },
    // 限制游客价格的输入
    onInputTouristPrice(index, price) {
      if (price == '.') {
        price = ''
      }
      let touristPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.tableData[index], "tourist_price", touristPrice);
    },
    // 限制库存数量的输入
    onInputSaleNum(index, num) {
      // console.log(num.toString().match(/^[1-9]\d*/));
      let saleNum = num.toString().match(/^[1-9]\d*/)
        ? num.toString().match(/^[1-9]\d*/)[0]
        : num === "0"
        ? "0"
        : "";
      this.$set(this.tableData[index], "sale_num", saleNum);
    },
    changeGradePrice(index, price) {
      if (price === '-') {
        this.$set(this.gradePriceTable[index], "gradePrice", '');
      }
    },
    // 限制等级价格的输入
    onInputGradePrice(index, price) {
      if (price == '.') {
        price = ''
      }
      let gradePrice = price.toString().match(/^(\d|-?)*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^(\d|-?)*(\.?\d{0,2})/g)[0]
        : "";
      gradePrice = gradePrice.toString()?gradePrice === '--'?'-':gradePrice:''
      let num = Number(gradePrice) + Number(this.tableData[this.priceItemsIndex].retail_price)
      if (num <= 0) {
      this.$set(this.gradePriceTable[index], "isGradePrice", 0);
      } else {
      this.$set(this.gradePriceTable[index], "isGradePrice", 1);
      }
      this.$set(this.gradePriceTable[index], "gradePrice", gradePrice);
    },
    // 限制指定价格的输入
    onInputDesignatedPrice(index, price) {
      if (price == '.') {
        price = ''
      }
      let DesignatedPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.clientTable[index], "itemPrice", DesignatedPrice);
    },
    // 限制统一设置市场价输入
    retailPrice(price) {
      // let retailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)[0] || null;
      let retailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.retail_price, "retail_price", retailPrice);
    },
    // 限制统一设置成本价输入
    costPrice(price) {
      // let costPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)[0] || null;
      let costPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.cost_price, "cost_price", costPrice);
    },
    // 统一运费
    carriage(price) {
      let freight = price.toString().match(/^\d*(\.?\d{0,2})/g)[0] || null;
      this.$set(this.ruleForm2, "uniformFreight", freight);
    },
    // 获取商品分类列表
    getGoodsClassify() {
      dbCommodity.getDBGoodsClassify().then((res) => {
        if (res.success) {
          // for (let i = 0; i < res.result.length; i++) {
          //   if (res.result[i].children.length < 1) {
          //     res.result[i].children = null;
          //   } else {
          //     for (let j = 0; j < res.result[i].children.length; j++) {
          //       if (res.result[i].children[j].children.length === 0) {
          //         res.result[i].children[j].children = null;
          //       }
          //     }
          //   }
          // }
          this.classify = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changeClassify() {
      if (
        this.ruleForm.classify[0] &&
        !this.ruleForm.classify[1] &&
        !this.ruleForm.classify[2]
      ) {
        this.classify.map((val) => {
          if (val.id == this.ruleForm.classify[0]) {
            setTimeout(() => {
              this.$refs.cascader.inputValue = val.cateName;
            }, 2000)
          }
        });
      }
    },
    // 获取商品标签
    getLabel() {
      dbCommodity.getDBLabel().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            if (res.result[i]) {
              this.$set(res.result[i], "state", false);
            }
          }
          this.labels = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取品牌数据
    getBrand() {
      dbCommodity.getCommodityAllBrand().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, Array) => {
            let obj = {};
            obj.name = value.name;
            obj.id = value.id;
            arr.push(obj);
          });
          this.brand = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取运费模板数据
    getFreight() {
      dbCommodity.getFreightAllList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.freight = arr;
        }
      });
    },
    // 获取等级价列表
    getGradePrice() {
      dbClient.getClientGradeList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            // obj.rebate = value.rebate;
            obj.gradePrice = "";
            arr.push(obj);
          });
          this.gradePriceTable = arr;
        }
      });
    },
    //获取参数数据
    getParameterData() {
      let searchValue = this.searchParameterName;
      let currentPage = this.page;
      let groupId = this.groupId
      dbCommodity.getParamsList(searchValue, currentPage, groupId).then((res) => {
        if (res.success) {
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.parameterName = value.name;
            obj.parameterValue = value.values;
            arr.push(obj);
          });
          this.parameterTable = arr;
        }
      });
    },
    //获取客户标签
    getClientTagList() {
      dbClient.getClientTagList().then((res) => {
        if (res.success) {
          // 先置空
          this.tagList = [];
          res.result.map((item) => {
            this.tagList.push({
              value: item.id,
              label: item.value,
            });
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    //获取客户列表
    getClientList() {
      const telephoneReg = /^1[0-9]{10}$/;
      let isTelephone = telephoneReg.test(Number(this.searchClientForm.key));
      let options = {
        name: isTelephone ? "" : this.searchClientForm.key,
        telephone: isTelephone ? this.searchClientForm.key : "",
        label: this.searchClientForm.tagId,
        currentPage: this.customerCurrentPage,
      };
      dbClient.getClientList(options).then((res) => {
        if (res.success) {
          let { totalNum, items } = res.result;
          this.customerTotalNum = totalNum;
          // 先置空
          this.clientList = [];
          items.map((item) => {
            let tagList = item.cusLabelValue ? item.cusLabelValue : [];
            let tags = [];
            if (item.name) {
              tagList.map((item) => {
                tags.push({
                  id: item.customerLabelId,
                  name: item.name,
                });
              });
              this.clientList.push({
                userId: item.userId,
                xbId: item.id,
                name: item.name,
                contact: item.contact,
                telephone: item.telephone,
                status: item.status,
                statusDesc: item.statusValue,
                tags: tags,
                createTime: item.createTime,
              });
            }
          });
        } else {
          console.log("没查询到客户");
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 根据id获取当前页数据
    getData() {
      let id = this.id;
      if (id) {
        dbCommodity.getDBDetailGoods(id).then((res) => {
          if (res.success) {
            this.ruleForm.name = res.result.goodsName;
            this.ruleForm.subheading = res.result.goodsInfo;
            this.ruleForm.code = res.result.code;
            this.ruleForm.label = res.result.labelList;
            this.isAnchoring = Boolean(res.result.isAnchoring);
            this.marketPriceAnchor = res.result.anchoring
            this.ruleForm.images = res.result.itemImages;
            this.ruleForm.saleImage = [res.result.saleImage];
            this.ruleForm.classify = [res.result.category1Id];
            if (
              res.result.category1Id &&
              !res.result.category2Id &&
              !res.result.category3Id
            ) {
              this.classify.map((val) => {
                if (val.id == res.result.category1Id) {
                  this.$refs.cascader.inputValue = val.cateName;
                }
              });
            }
            if (res.result.category2Id) {
              this.ruleForm.classify.push(res.result.category2Id);
              if (res.result.category3Id) {
                this.ruleForm.classify.push(res.result.category3Id);
              }
            }
            // 判断品牌数据是否有
            if (res.result.brandId === 0 || res.result.brandId === "") {
              this.ruleForm.brand = "";
            } else {
              this.ruleForm.brand = res.result.brandId;
            }
            // this.brand.map(value => {
            //   if (value.id === res.result.brandId) {
            //     this.ruleForm.brand = res.result.brandId;
            //   }
            // });
            this.ruleForm.weight = res.result.weight;
            this.ruleForm.status = res.result.status;
            this.ruleForm.parameterData = res.result.paramIds;
            if (this.ruleForm.parameterData.length > 0) {
              this.isSettingParameter = true;
            }

            /* 获取展示选中的参数 */
            setTimeout(() => {
              let selectParameterArr = []
              let tempArr = []
              this.ruleForm.parameterData.map((item, index) => {
                if (tempArr.indexOf(item.name) === -1) {
                  let selectParameterObj = {}
                  let selectParameterValuesObj = {}
                  selectParameterObj.values = []
                  selectParameterObj.name = item.name
                  selectParameterValuesObj.id = item.id
                  selectParameterValuesObj.value = item.value
                  selectParameterObj.values.push(selectParameterValuesObj)
                  selectParameterArr.push(selectParameterObj)
                  tempArr.push(item.name)
                } else {
                  
                  for (let j = 0; j < this.ruleForm.parameterData.length; j++) {
                    if (selectParameterArr[j].name== this.ruleForm.parameterData[index].name) {
                        let valueObj = {}
                        valueObj.id = this.ruleForm.parameterData[index].id
                        valueObj.value = this.ruleForm.parameterData[index].value
                        selectParameterArr[j].values.push(valueObj)
                      break;
                    }
                  }
                }
              })
              this.selectParameterArr = selectParameterArr
            })

            this.fileList = [];
            this.ruleForm.images.map((value) => {
              let obj = {};
              obj.url = value;
              this.fileList.push(obj);
            });
            this.saleFileList = [];
            this.ruleForm.saleImage.map((value) => {
              let obj = {};
              obj.url = value;
              this.saleFileList.push(obj);
            })
            let specificationItems = res.result.specificationItems;
            let specification = []
            specificationItems.map((value, index, array) => {
              let obj = {};
              obj.title = value.name;
              obj.dynamicTags = value.value;
              obj.inputVisible = false;
              obj.inputValue = "";
              specification.push(obj);
            });
            this.specification = specification;
            this.priceSwitch = res.result.levelStatus === 1;
            this.items = res.result.items;
            this.getJsonp(res.result.introduction);
            this.ruleForm2.resource = res.result.isDefaultTraffic;
            this.ruleForm2.uniformFreight = res.result.trafficCost;
            this.ruleForm2.freightId = res.result.trafficId;
          }
        });
      } else {
        dbSiteSet.getDBSiteSystemSetting().then((res) => {
          if (res.result) {
            let { marketPriceAnchoring } = res.result
            this.isAnchoring = Boolean(marketPriceAnchoring)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    //打开参数弹窗
    openParameterDialog() {
      this.dialogParameterVisible = true;
      let arr = JSON.parse(
        JSON.stringify(this.ruleForm.parameterData)
      );
      let checkedList = []
      arr.map(i => {
        let str = i.id+':'+i.value
        checkedList.push(str)
      })
      this.parameterCheckedData = checkedList
      this.selectParameterList = arr
    },
    //筛选参数
    searchParameter() {
      this.searchParameterName = this.parameterName;
      this.page = 1;
      this.getParameterData();
    },
    //参数翻页
    updatePage(data) {
      this.page = data.currentPage;
      this.getParameterData();
    },
    //保存参数
    saveParameter() {
      this.ruleForm.parameterData = JSON.parse(
        JSON.stringify(this.selectParameterList)
      );
      this.dialogParameterVisible = false;
    },
    // 删除规格列表数据
    removeSpecifications(id) {
      dbCommodity.getRemoveSpecification(id).then((res) => {
        if (res.success) {
          this.specificationList.map((value, index) => {
            if (value.id === id) {
              this.specificationList.splice(index, 1);
            }
          });
        }
      });
    },
    // 删除属性
    removeSpecificationsOption(id, title) {
      let ID = this.specificationList.filter(function (item) {
        return item.value === title;
      })[0].id;
      dbCommodity.getRemoveSpecificationOption(id).then((res) => {
        if (res.success) {
          this.specificationList.map((value, index) => {
            if (value.id === ID) {
              value.labels.map((v, i) => {
                if (v.id === id) {
                  this.specificationList[index].labels.splice(i, 1);
                }
              });
            }
          });
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 图片数量大于6
    handleLimit() {
      this.$message({
        message: "图片数量最多6张",
        type: "warning",
      });
    },
    // 销售授权图片数量大于1
    handSaleleLimit() {
      this.$message({
        message: "图片数量最多1张",
        type: "warning",
      });
    },
    // 销售授权图片数量大于1
    handSaleleLimit() {
      this.$message({
        message: "图片数量最多1张",
        type: "warning",
      });
    },
    // 删除图片
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.ruleForm.images = [];
      this.fileList.map((value, index, Array) => {
        this.ruleForm.images.push(value.url);
      });
    },
    // 删除销售授权图片
    onSaleRemove(file, fileList) {
      this.saleFileList = fileList;
      this.ruleForm.saleImage = [];
      this.saleFileList.map((value, index, Array) => {
        this.ruleForm.saleImage.push(value.url);
      });
    },
    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        // const formData = new FormData();
        // formData.append('pic', this.file);
        // console.log(this.file);
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.ruleForm.images = [];
              this.fileList.map((value, index, Array) => {
                this.ruleForm.images.push(value.url);
              });
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
        // console.log(file);
      }
    },
    // 上传销售授权图片进行判断图片
    beforeSaleUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        // this.fileList = this.fileList.splice(1, )
        return false;
      } else {
        this.saleLoading = true;
        this.saleFile = file;
        // const formData = new FormData();
        // formData.append('pic', this.file);
        // console.log(this.file);
        imgUploader
          .postImgUpload(this.saleFile)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.saleFileList.push(obj);
              this.saleLoading = false;
              this.ruleForm.saleImage = [];
              this.saleFileList.map((value, index, Array) => {
                this.ruleForm.saleImage.push(value.url);
              });
            } else {
              this.saleLoading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.saleLoading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
        // console.log(file);
      }
    },
    // 权重判断
    math(value) {
      // console.log(Object.prototype.toString.call(value));
      // console.log(!isNaN(Number(value)));
      if (isNaN(Number(value))) {
        this.$message.error("请输入正确的权重!");
        this.ruleForm.weight = "";
      } else if (Number(value) > 1000 || Number(value) < 1) {
        this.$message.error("请输入1到1000中的数字!");
        this.ruleForm.weight = "";
      } else {
        this.ruleForm.weight = value.split(".")[0];
      }
    },
    // 获取规格所有数据
    getSpecification() {
      dbCommodity.getDBSpecification().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, Array) => {
            let object = {};
            object.id = value.id;
            object.value = value.name;
            object.label = value.name;
            object.labels = [];
            value.specificationOptionList.map((value, index, Array) => {
              let obj = {};
              obj.id = value.id;
              obj.value = value.optionName;
              obj.label = value.optionName;
              object.labels.push(obj);
            });
            arr.push(object);
          });
          this.specificationList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 规格设置,判断是否为新分类数据，添加新的数据
    changeValue1(callback, vc) {
      if (callback === false && vc !== "") {
        let obj = {
          value: vc,
          label: vc,
          labels: [],
        };
        // const that = this;
        let val = true;
        this.specificationList.forEach((value, index, array) => {
          if (array[index].value === vc) {
            val = false;
            // that.specificationList_child.push(this.specificationList[index].labels[0])
            // console.log(that.specificationList_child);
          }
        });
        if (val) {
          this.specificationList.push(obj);
          dbCommodity.postDBAddSpecification(vc).then((res) => {
            this.getSpecification();
          });
        }
      }
    },
    changeSelect(index) {
      if (this.specification[index].dynamicTags.length > 0) {
        // this.specification.splice(index, 1);
        this.specification[index].dynamicTags = [];
      }
    },
    // 添加规格按钮，大于等于3时，不能点击
    addSpecification() {
      if (this.specification.length === 0) {
        this.specification.push({
          title: "",
          dynamicTags: [],
          inputVisible: false,
          inputValue: "",
        });
      } else if (
        this.specification.length > 0 &&
        this.specification.length < 3
      ) {
        let last = this.specification[this.specification.length - 1];
        if (last.title !== "" && last.dynamicTags.length > 0) {
          this.specification.push({
            title: "",
            dynamicTags: [],
            inputVisible: false,
            inputValue: "",
          });
        } else {
          this.$message.warning("请先选择规格 ！");
        }
      }
    },
    // 标签删除按钮
    handleClose(tag, index) {
      this.specification[index].dynamicTags.splice(
        this.specification[index].dynamicTags.indexOf(tag),
        1
      );
    },
    // 点击添加标签按钮，产生input
    showInput(index) {
      if (this.specification[index].title) {
        this.specification[index].inputVisible = true;
        this.$nextTick((_) => {
          this.$refs.saveTagInput[0].$children[0].$refs.input.focus();
        });
      } else {
        this.$message.warning("请先选择规格!");
      }
    },
    // input获取焦点、失去焦点
    handleInputConfirm(callback, vc, index, title) {
      let inputValue = vc;
      // console.log(title);
      // 获取列表单index
      var specificationListindex = this.specificationList.indexOf(
        this.specificationList.filter(function (item) {
          return item.value === title;
        })[0]
      );
      // 判断labels中是否存在数值vc,有不用管，没有添加
      let labels = this.specificationList[specificationListindex].labels;
      let indexof =
        this.specification[index].dynamicTags.indexOf(inputValue) === -1;
      if (inputValue && indexof) {
        this.specification[index].dynamicTags.push(inputValue);
        this.specification[index].inputVisible = false;
        this.specification[index].inputValue = "";
        let obj = {
          value: inputValue,
          label: inputValue,
        };
        // const that = this;
        let val = true;
        labels.forEach((value, index, array) => {
          if (array[index].value === inputValue) {
            val = false;
          }
        });
        if (val) {
          this.specificationList[specificationListindex].labels.push(obj);
          let optionName = inputValue;
          let specId = this.specificationList[specificationListindex].id;
          dbCommodity
            .postDBAddSpecificationChild(optionName, specId)
            .then((res) => {
              if (res.success) {
                console.log(res.success);
                this.getSpecification();
              } else {
                this.$message.error(res.message);
              }
            });
        }
        // console.log( Object.keys(this.tableData[0]).length);
        // console.log(Object.getOwnPropertyNames(this.tableData[0])[0]);
        // console.log(this.tableData);
      } else if (!indexof) {
        this.specification[index].inputVisible = false;
        this.specification[index].inputValue = "";
        this.$message.error("规格不能重复 !");
      } else if (!callback && !inputValue) {
        this.specification[index].inputVisible = false;
        this.specification[index].inputValue = "";
      }
    },
    // 删除规格条数
    remove(index) {
      this.title.splice(index, 1);
      this.specification.splice(index, 1);
    },
    // 合并列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.specification.length === 1) {
        // let math1 = this.specification[0].dynamicTags.length;
      } else if (
        (this.specification.length === 2 &&
          this.specification[1].dynamicTags.length > 0) ||
        (this.specification.length === 3 &&
          this.specification[2].dynamicTags.length === 0)
      ) {
        let math1 = this.specification[0].dynamicTags.length;
        let math2 = this.specification[1].dynamicTags.length;
        let spanArr = [];
        for (let i = 0; i < math1; i++) {
          for (let j = 0; j < math2; j++) {
            if (j === 0) {
              spanArr.push(math2);
            } else {
              spanArr.push(0);
            }
          }
        }
        // 第一列进行合并
        if (columnIndex === 0) {
          const _row = spanArr[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      } else if (
        this.specification.length === 3 &&
        this.specification[2].dynamicTags.length > 0
      ) {
        let math1 = this.specification[0].dynamicTags.length;
        let math2 = this.specification[1].dynamicTags.length;
        let math3 = this.specification[2].dynamicTags.length;
        let spanArr1 = [];
        let spanArr2 = [];
        for (let i = 0; i < math1; i++) {
          for (let j = 0; j < math2 * math3; j++) {
            if (j === 0) {
              spanArr1.push(math2 * math3);
            } else {
              spanArr1.push(0);
            }
          }
        }
        for (let i = 0; i < math1; i++) {
          for (let j = 0; j < math2; j++) {
            for (let k = 0; k < math3; k++) {
              if (k === 0) {
                spanArr2.push(math3);
              } else {
                spanArr2.push(0);
              }
            }
          }
        }
        if (columnIndex === 0) {
          const _row = spanArr1[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
        if (columnIndex === 1) {
          const _row = spanArr2[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    // 点击清空操作
    handleDelete(index, row) {
      row.erpId = "";
      row.cost_price = "";
      row.sale_num = "";
      row.retail_price = "";
    },
    // 统一零售价
    changeRetail_price(num) {
      for (var i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], "retail_price", num);
      }
      this.retail_price = {
        visible: false,
        retail_price: "",
      };
    },
    // 统一成本价
    changeCost_price(num) {
      for (var i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], "cost_price", num);
        if (this.isAnchoring) {
          let RetailPrice = Number(num) + Number(this.marketPriceAnchor)
          this.$set(this.tableData[i], "retail_price", RetailPrice);
        }
      }
      this.cost_price = {
        visible: false,
        cost_price: "",
      };
    },
    // 取消
    cancalRetail_price() {
      this.retail_price = {
        visible: false,
        retail_price: "",
      };
    },
    // 取消
    cancalCost_price() {
      this.cost_price = {
        visible: false,
        cost_price: "",
      };
    },
    // 设置等级价
    setGradePrice(index, row) {
      if (row.retail_price) {
        this.dialogGradePriceVisible = true;
        this.priceItemsIndex = index;
        if (row.levelPriceStatus === 0) {
          this.gradePriceTable.map((value) => {
            // value.gradePrice = (
            //   (row.retail_price * value.rebate) /
            //   100
            // ).toFixed(2);
            value.gradePrice = ''
            value.isGradePrice = 1
          });
        } else {
          this.gradePriceTable.map((value, index) => {
            value.gradePrice = "";
            row.itemLevelPriceList.map((val, ind) => {
              if (val.levelId === value.id) {
                value.gradePrice = row.itemLevelPriceList[ind].increment;
                value.isGradePrice = 1
              }
            });
            // if (row.itemLevelPriceList[index]) {
            //   value.gradePrice = row.itemLevelPriceList[index].itemPrice;
            // }
          });
        }
      } else {
        this.$message.error("请设置市场价");
      }
    },
    // 重置等级价
    resetGradePrice() {
      let index = this.priceItemsIndex;
      this.gradePriceTable.map((value) => {
        // value.gradePrice = (
        //   (this.tableData[index].retail_price * value.rebate) /
        //   100
        // ).toFixed(2);
        // value.gradePrice = (this.tableData[index].retail_price).toFixed(2);
        value.gradePrice = '';
      });
    },
    // 保存等级价
    saveGradePrice() {
      let stop = false;
      let isGradePrice = false;
      let arr = [];
      this.gradePriceTable.map((value) => {
        let obj = {};
        obj.levelId = value.id;
        if (value.gradePrice === "") {
          obj.increment = null;
          // stop = true;
        }
        //  else if (value.gradePrice === "0") {
        //   stop = true;
        // } 
         else if (value.isGradePrice === 0) {
          isGradePrice = true;
        } 
        else {
          obj.increment = Number(value.gradePrice);
        }
        arr.push(obj);
      });
      if (isGradePrice) {
        this.$message.error("等级价必须大于0");
        return false;
      }
      if (stop) {
        this.$message.error("等级价不能为空");
        return false;
      } else {
        let index = this.priceItemsIndex;
        let levelPriceStatus = 0;
        arr.map((item) => {
          if (item.increment) {
            levelPriceStatus = 1;
          }
        });
        this.tableData[index].levelPriceStatus = levelPriceStatus;
        this.tableData[index].itemLevelPriceList = arr;
        this.cancelGradePrice();
      }
    },
    // 取消等级价
    cancelGradePrice() {
      this.dialogGradePriceVisible = false;
    },
    //设置指定价
    setDesignatedPrice(index, row) {
      this.dialogDesignatedPriceVisible = true;
      this.priceItemsIndex = index;
      this.clientTable = row.itemCusPriceList;
    },
    //搜索客户
    searchClient() {
      this.searchClientForm = this.clientForm;
      this.customerCurrentPage = 1;
      this.getClientList();
    },
    //选择客户
    handleSelectionClient(val) {
      this.selectionClient = val;
    },
    //客户翻页
    customerUpdatePage(data) {
      this.customerCurrentPage = data.currentPage;
      this.getClientList();
    },
    //客户列表点击取消
    closeClientList() {
      this.isShowClientListDialog = false;
      this.$refs.multipleTable.clearSelection();
    },
    //保存选取的客户
    saveSelectClient() {
      let arr = [];
      this.selectionClient.map((value) => {
        let id = value.userId;
        let stop = false;
        this.clientTable.map((item) => {
          let userId = item.userId;
          if (id === userId) {
            stop = true;
          }
        });
        if (!stop) {
          let obj = {};
          obj.userId = value.userId;
          obj.xbName = value.name;
          obj.itemPrice = "";
          arr.push(obj);
        }
      });
      this.clientTable = this.clientTable.concat(arr);
      if (this.selectionClient.length > 0) {
        this.$message({
          message: "添加成功",
          type: "success",
          duration: 1000,
        });
      } else {
        this.$message({
          message: "请选择客户",
          type: "error",
          duration: 1000,
        });
      }
    },
    //删除客户
    deleteSelectclient(index) {
      this.clientTable.splice(index, 1);
    },
    //关闭指定价弹窗
    closeDesignatedPriceVisible() {
      this.dialogDesignatedPriceVisible = false;
    },
    //保存指定价
    saveDesignatedPrice() {
      let index = this.priceItemsIndex;
      // if (this.clientTable.length > 0) {
      let isPrice = false;
      this.clientTable.map((value) => {
        if (value.itemPrice === "") {
          isPrice = true;
        }
      });
      if (!isPrice) {
        this.tableData[index].itemCusPriceList = this.clientTable;
        if (this.tableData[index].itemCusPriceList.length > 0) {
          this.tableData[index].cusPriceStatus = 1;
        } else {
          this.tableData[index].cusPriceStatus = 0;
        }
        this.closeDesignatedPriceVisible();
      } else {
        this.$message({
          message: "请输入指定价",
          type: "error",
          duration: 1000,
        });
      }
      // } else {
      //   this.$message({
      //     message: "请选择客户",
      //     type: "error",
      //     duration: 1000
      //   });
      // }
    },
    //显示客户弹窗
    openClientListDialog() {
      this.isShowClientListDialog = true;
    },
    // 富文本编辑器内容
    catchData(value) {
      console.log(value);
      this.ruleForm.content = value; // 在这里接受子组件传过来的参数，赋值给data里的参数
    },
    // 添加运费模板
    addTemplate() {
      this.$router.push("/admin/commodity/freight/freight-manage");
    },
    // jsonp
    getJsonp(url) {
      if (url) {
        var hash = new Date().getTime();
        let script = document.createElement("script");
        this.content = "";
        script.src = url + `?hash=${hash}`;
        document.body.appendChild(script);
        window.jsonpCallBack = (response) => {
          setTimeout(() => {
            let str = response.content;
            this.ruleForm.content = str;
            this.content = str;
            let drayImgCloneToEditor = document.querySelector(
              ".dropImgToEditor > #wangeditor > div > .w-e-text-container > .w-e-text > p"
            );
            drayImgCloneToEditor.click()
            this.isFinishDataLoading = false

          },1500)
        };
        script.onload = function (e) {
          e.currentTarget.remove();
          delete window.jsonpCallBack;
        };
        script.onerror = function (e) {
          // alert("数据请求失败");
          e.currentTarget.remove();
          delete window.jsonpCallBack;
        };
        // window.jsonpCallback = (response) => {
        //   let str = response.content;
        //   this.ruleForm.content = str;
        //   this.content = str;
        //   this.$nextTick(() => {
        //     this.isFinishDataLoading = false
        //   })
        // };
        // script.onload = function (e) {
        //   e.currentTarget.remove();
        //   delete window.jsonpCallback;
        // };
        // script.onerror = function (e) {
        //   // alert("数据请求失败");
        //   e.currentTarget.remove();
        //   delete window.jsonpCallback;
        // };
      }
    },
    // 保存
    submit(formName1, formName2) {
      setTimeout(() => {
        let goodsName = this.ruleForm.name;
        let goodsInfo = this.ruleForm.subheading;
        let levelStatus = this.priceSwitch ? 1 : 0;
        let category1Id = this.ruleForm.classify[0];
        let category2Id = this.ruleForm.classify[1]
          ? this.ruleForm.classify[1]
          : "";
        let category3Id = this.ruleForm.classify[2]
          ? this.ruleForm.classify[2]
          : "";
        let weight = this.ruleForm.weight;
        let code = this.ruleForm.code === "" ? null : this.ruleForm.code;
        let labelList = this.ruleForm.label;
        let status = this.ruleForm.status;
        let parameterData= []
        this.ruleForm.parameterData.map(i => {
          parameterData.push(Number(i.id))
        })
        
        if (window.location.host == 'www.it-nd.com') {
          if (parameterData.length == 0) {
            this.$message.error("请设置商品参数!");
            return false;
          }
        }
        let paramIds = parameterData;
        let brandId = this.ruleForm.brand;
        let itemImages = this.ruleForm.images;
        // let saleImage = this.ruleForm.saleImage[0];
        let isDefaultTraffic = this.ruleForm2.resource;
        let trafficCost = this.ruleForm2.uniformFreight;
        let trafficId = this.ruleForm2.freightId;
        let isAnchoring = this.isAnchoring?1:0;
        let anchoring = Number(this.marketPriceAnchor);
        let items = [];
        let obj1 = {
          content: this.ruleForm.content,
        };
        let obj2 = JSON.stringify(obj1);
        let introduction = `jsonpCallBack(${obj2})`;
        // 规格数据整合
        let arr = [];
        this.specification.map((value, index, array) => {
          if (value.dynamicTags.length > 0) {
            let obj = {};
            obj.name = value.title;
            obj.value = value.dynamicTags;
            arr.push(obj);
          }
        });

        let specificationItems = arr;
        if (specificationItems.length === 0) {
          this.$message.error("请输入规格!");
          return false;
        }
        let stop= false
        let isFlag = false
        // 整理表格数据
        this.tableData.map((value, index, array) => {
          let obj = {};
          let object = {};
          let length = this.ruleForm.classify.length - 1;
          for (let i = 0; i < arr.length; i++) {
            obj[arr[i].name] = value[arr[i].name];
          }
          object.specInfo = obj;
          object.levelPriceStatus = value.levelPriceStatus;
          value.itemLevelPriceList.map(val => {
            let num = Number(value.retail_price) + Number(val.increment)
            if (num <= 0) {
                stop = true
            }
          })
          object.itemLevelPriceList = value.itemLevelPriceList;
          object.cusPriceStatus = value.cusPriceStatus;
          object.itemCusPriceList = [];
          value.itemCusPriceList.map((item) => {
            let itemObj = {};
            itemObj.userId = item.userId;
            itemObj.itemPrice = Number(item.itemPrice);
            object.itemCusPriceList.push(itemObj);
          });
          object.erpId = value.erpId;
          object.marketPrice = Number(value.retail_price);
          object.basePrice = Number(value.cost_price);
          if (Number(value.tourist_price) < 0) {
            isFlag = true
          }
          object.visitorIncrement = Number(value.tourist_price);
          object.saleNum = Number(value.sale_num);
          object.categoryId = this.ruleForm.classify[length];
          if (value.skuId) {
            object.id = value.skuId;
          }
          items.push(object);
        });
        if (stop) {
          this.$message.error("等级价必须大于0");
          return
        }
        if (isFlag) {
          this.$message.error("游客价必须大于等于0");
          return
        }
        if (!this.ruleForm.code&&this.id) {
          this.$message.error("商品编码不能为空");
          return
        }
        const data = {
          goodsName,
          levelStatus,
          goodsInfo,
          category1Id,
          category2Id,
          category3Id,
          weight,
          code,
          status,
          paramIds,
          labelList,
          itemImages,
          isAnchoring,
          anchoring,
          // saleImage,
          specificationItems,
          isDefaultTraffic,
          brandId,
          trafficCost,
          items,
          trafficId,
          introduction,
        };
        this.$refs[formName1].validate((valid) => {
          if (valid) {
            this.$refs[formName2].validate((valid) => {
              if (valid) {
                let leng = Object.keys(this.tableData[0]).length;
                if (leng === 5) {
                  this.$message.error("请设置规格");
                } else if (
                  this.ruleForm2.freightId === "" &&
                  this.ruleForm2.resource === false
                ) {
                  this.$message.error("运费设置不能为空");
                } else {
                  if (this.id) {
                    this.isFinishDataLoading = true
                    data.id = this.id;
                    dbCommodity.postDBUpdateCoods(data).then((res) => {
                      if (res.success) {
                        this.$message.success("修改成功！");
                        this.getData()
                      } else {
                        this.isFinishDataLoading = false
                        this.$message.error(res.message);
                      }
                    });
                  } else {
                    dbCommodity.postDBAddGoods(data).then((res) => {
                      if (res.success) {
                        this.$message.success("添加商品成功！");
                        this.$router.push({
                          name: "commodity-list",
                          params: {
                            change: true,
                          },
                        });
                      } else {
                        this.$message.error(res.message);
                      }
                    });
                  }
                }
              } else {
                this.$message.error("请输入完整信息！");
                return false;
              }
            });
          } else {
            this.$message.error("请输入完整信息！");
            return false;
          }
        });
      },200)
    },
    cancal() {
      this.$router.push({
        name: "commodity-list",
        params: {
          change: true,
        },
      });
    },
    toPreviewProduct(id) {
      window.open(`/admin/preview-product?id=${id}`, "_blank");
    },
    moveParameterNameselecd(index, id) {
      this.activeMoveParameterNameIndex = index
      this.groupId = id
      this.getParameterData()
    },
    /* 获取参数组 */
    initParameterGroupList() {
      let groupName = this.parameterNameGroupSearch
      dbCommodity.getParameterGroupList(groupName).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.nums = i.countParams
            arr.push(obj)
          })
          this.parameterGroupList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCheckedCitiesChange(val) {
      let arr = []
      val.forEach(item=>{
        let obj = {}
        const value = item.split(':')[0];
        const label= item.split(':')[1];
        obj.id = value
        obj.value = label
        arr.push(obj)
      });
      this.selectParameterList = arr
    },
    deleteParameter(id, v) {
      this.selectParameterList.splice(v, 1)
      this.parameterCheckedData.map((i, index) => {
        if (i.split(':')[0] == id) {
          this.parameterCheckedData.splice(index, 1)
        }
      })
    },
    /* 搜索参数组 */
    searchParameterGroup() {
      this.initParameterGroupList()
    },
  },
};
</script>

<style lang="scss" scoped>
.add-commodity {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .active {
    white-space: wrap;
    .el-checkbox-group {
      height: 100%!important;
    }
  }
  .add-commodity-main {
    letter-spacing: 1px;
    .gradePrice {
      margin-left: 20px;
      color: red;
    }
    .AddProductContainer {
      .title {
        height: 32px;
        background: rgba(245, 247, 250, 1);
        border-radius: 8px 8px 0px 0px;
        font-size: 16px;
        padding-left: 6px;
        letter-spacing: 1px;
        line-height: 32px;
        color: #303132;
        cursor: default;
      }
      .information,
      .specification-inventory,
      .product-details,
      .logistics-other {
        padding-bottom: 20px;
      }
      /* 商品信息 */
      .information {
        .information-container {
          padding-top: 20px;
        }
      }
      /* 商品规格 */
      .specification-inventory {
        letter-spacing: 1px;
        .specification-title {
          width: 110px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          color: #606266;
          text-align: right;
          box-sizing: border-box;
          padding-right: 10px;
        }
        .specification-setting {
          margin-top: 16px;
          display: flex;
          .add-specification {
            flex: 1;
            padding: 16px;
            background: rgba(224, 231, 255, 0.2);
            border-radius: 4px;
            border: 1px solid rgba(224, 231, 255, 1);
            .specification-list {
              .select {
                height: 42px;
                background: rgba(234, 238, 245, 1);
                border-radius: 8px;
                opacity: 0.75;
                border: 1px solid rgba(227, 231, 237, 1);
                box-sizing: border-box;
                display: flex;
                padding: 0 18px 0 15px;
                align-items: center;
                justify-content: space-between;
                .remove {
                  width: 18px;
                  height: 18px;
                  background: url(../../../../assets/images/remove.png);
                  background-size: cover;
                  display: none;
                }
              }
              .select:hover {
                .remove {
                  display: inline-block;
                }
              }
              .label {
                min-height: 28px;
                padding: 5px 0;
              }
            }
            .add {
              height: 48px;
              background: rgba(234, 238, 245, 1);
              border-radius: 8px;
              opacity: 0.75;
              border: 1px solid rgba(227, 231, 237, 1);
              display: flex;
              align-items: center;
              box-sizing: border-box;
              .add-button {
                width: 128px;
                height: 32px;
                background: rgba(61, 116, 242, 0.8);
                border-radius: 4px;
                border: 0;
                color: #fff;
                font-size: 14px;
                line-height: 8px;
                margin-left: 17px;
                letter-spacing: 1px;
              }
              .add-button:hover {
                background: rgba(61, 116, 242, 1);
              }
              .ECEEF5 {
                background: #aaa;
              }
              .ECEEF5:hover {
                background: #aaa;
              }
            }
          }
        }
        .price-switch {
          margin-top: 16px;
          padding-left: 110px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #666666;
          .text {
            margin-left: 10px;
          }
        }
        .market-price {
          margin-left: 42px;
          .text {
            margin-left: 8px;
          }
        }
        .specification-message {
          margin-top: 16px;
          display: flex;
          .table {
            flex: 1;
            padding: 16px;
            background: rgba(224, 231, 255, 0.2);
            border-radius: 4px;
            border: 1px solid rgba(224, 231, 255, 1);
            .handle {
              height: 32px;
              padding-left: 16px;
              display: flex;
              align-items: center;
              background: #fff;
              letter-spacing: 1px;
              border: 1px solid #f0f5f9;
              border-top: 0px;
              .handle-p {
                color: #606266;
                font-size: 14px;
                padding-right: 4px;
              }
              .handle-ul {
                display: flex;
                align-items: center;
                .el-button {
                  height: 32px;
                  line-height: 0;
                  color: #3d74f2;
                  font-size: 12px;
                  margin-left: 20px;
                }
              }
            }
          }
        }
      }
      /* 商品详情 */
      .product-details {
        width: 100%;
        .editor-container {
          width: 100%;
          padding: 24px 0px 0 0px;
        }
      }
      /* 物流其他 */
      .logistics-other {
        .logistics-other-container {
          width: 400px;
          padding: 16px 0 10px 30px;
          overflow: hidden;
        }
      }
      /* 底部按钮 */
      .operations {
        z-index: 300;
        height: 60px;
        position: fixed;
        left: 256px;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
        .el-button {
          width: 96px;
          letter-spacing: 4px;
        }
        .el-button + .el-button {
          margin-left: 24px;
        }
      }
    }
  }
  .dialog-parameter-main {
    height: 618px;
    display: flex;
    justify-content: flex-start;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    .dialog-parameter-left {
      width: 176px;
      overflow-y: scroll;
      border-right: 1px solid #e5e5e5;
      .top-search {
        padding-bottom: 6px;
      }
      .parameter-group {
        .parameter-group-row {
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          padding: 0px 16px;
          cursor: pointer;
        }
        .parameter-group-active {
          color: #3d74f2;
          background: #f5f8fe;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            right: 0px;
            top: 6px;
            width: 4px;
            height: 24px;
            background: #3D74F2;
          }
        }
      }
    }
    .dialog-parameter-right {
      width: 592px;
      display: flex;
      flex-direction: column;
      .dialog-parameter-search {
        border-bottom: 1px solid #EEE;
      }
      .select-parameter {
        font-size: 12px;
        font-weight: 400;
        color: #888888;
        line-height: 24px;
        opacity: 0.62;
        padding-left: 25px;
      }
      .select-row {
        height: 80px;
        overflow-y: auto;
        margin: 0px 16px 10px 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .select-item {
          width: 108px;
          height: 32px;
          box-sizing: border-box;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 10px;
          margin-right: 16px;
          padding: 9px;
          display: flex;
          justify-content: space-between;
          position: relative;
          .parameter-name {
            width: 72px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .delete-parameter {
            display: none;
            position: absolute;
            right: 9px;
            font-size: 16px;
          }
          &:hover {
            background: #F5F7FA;
            .delete-parameter {
              display: block;
              color: #409EFF;
            }
          }
        }
      }
      .dialog-parameter-table {
        padding: 0px 16px;
      }
    }
  }
}
</style>
<style lang="scss">
.add-commodity {
  .dialog-parameter-input {
    .el-input__icon {
      line-height: 34px;
    }
    .el-input__inner {
      border-radius: 0px;
      border: 0px;
    }
  }
  .w60 {
    width: 120px;
    margin-left: 8px;
    .el-input__inner {
      height: 24px;
    }
  }
  /* 商品信息 */
  .information-container {
    .el-form {
      .labels-containor {
        .el-checkbox-group {
          height: 32px;
        }
      }
      .flex {
        display: flex;
        .el-form-item {
          flex: 1;
        }
      }
      .w320 {
        .el-form-item__content {
          width: 320px;
        }
      }
      .w270 {
        .el-form-item__content {
          width: 270px;
          .gray {
            width: 270px;
            line-height: 32px;
            .el-input--suffix {
              line-height: 32px;
              .el-input__inner {
                height: 32px;
                background: rgba(234, 238, 245, 0.2);
                border-color: #eaeef5;
              }
            }
            .el-input__suffix {
              height: 40px;
              top: -3px;
              right: 0px;
            }
            .is-focus {
              .el-input__inner {
                border: 1px solid rgba(61, 116, 242, 1);
              }
            }
          }
        }
      }
      .w100 {
        .el-form-item__content {
          width: 100px;
          position: relative;
          .weight {
            position: absolute;
            font-size: 12px;
            right: -272px;
            top: 5px;
          }
        }
      }
      .images {
        height: auto;
        margin-bottom: 0;
        .el-form-item__content {
          height: auto;
          .el-upload-list {
            .el-upload-list__item {
              width: 128px;
              height: 128px;
              margin-top: 0px;
            }
          }
          .el-upload--picture-card {
            width: 128px;
            height: 128px;
            border: 0px;
            line-height: 0px;
            .el-upload-list__item-thumbnail {
              height: 128px;
            }
          }
          .authorize {
            .el-upload-list__item-delete {
              display: none;
            }
          }
          .w50 {
            width: 50%;
          }
          .none {
            .el-upload--picture-card {
              display: none;
            }
          }
          .el-button {
            width: 128px;
            height: 128px;
            background: rgba(234, 238, 245, 0.2);
            border-radius: 8px;
            border: 1px solid rgba(234, 238, 245, 1);
            > span {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .add {
                width: 22px;
                height: 22px;
                line-height: 22px;
                color: #3d74f2;
                margin-bottom: 10px;
                border: 2px solid #3d74f2;
                border-radius: 50%;
                font-size: 22px;
              }
              .max {
                color: rgba(192, 196, 204, 1);
                line-height: 20px;
              }
            }
          }
          .el-upload__tip {
            margin: 0;
            color: rgba(192, 196, 204, 1);
            line-height: 20px;
          }
          ul {
            width: 320px;
          }
        }
      }
    }
    .parameter-item {
    position: relative;

    }
    .select-parameter-show {
      position: absolute;
      left: 0px;
      top: 52px;
      width: 358px;
      height: 185px;
      z-index: 888;
      .cell {
        display: flex;
        flex-wrap: wrap;
        height: auto !important;
        line-height: auto !important;
        .show-parameter {
          margin-right: 30px;
        }
      }
    }
  }
  /* 商品规格 */
  .specification-inventory {
    /* 头部下拉设置 */
    .select {
      .el-select {
        height: 28px;
        width: 160px;
        position: relative;
        .el-input__inner {
          height: 28px;
          color: #606266;
          width: 160px;
          background: #fff;
          border-radius: 4px;
          border: 1px solid rgba(234, 238, 245, 1);
          letter-spacing: 1px;
        }
        .el-input__suffix {
          position: absolute;
          top: -5px;
          height: 40px;
        }
      }
    }
    /* 标签设置 */
    .label {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .el-tag {
        margin-left: 10px;
        margin-top: 5px;
        margin-bottom: 5px;
        height: 28px;
        min-width: 108px;
        max-width: 158px;
        line-height: 26px;
        background: rgba(224, 231, 255, 0.2);
        border-radius: 4px;
        border: 1px solid rgba(61, 116, 242, 1);
        box-sizing: border-box;
        text-align: center;
        position: relative;
        font-size: 14px;
        color: #3d74f2;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        .el-tag__close {
          right: 4px;
          top: 5px;
          display: none;
          position: absolute;
        }
      }
      .el-tag:hover {
        .el-tag__close {
          display: inline-block;
        }
      }
      .button-new-tag {
        margin-left: 10px;
        height: 28px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
        color: #3d74f2;
        width: 50px;
        text-align: center;
      }
      .el-select {
        height: 28px;
        line-height: 28px;
        width: 100px;
        max-width: 150px;
        position: relative;
        margin-left: 10px;
        .el-input__inner {
          height: 28px;
          line-height: 28px;
          color: #606266;
          /* min-width: 100px; */
          background: #fff;
          border-radius: 4px;
          border: 1px solid rgba(234, 238, 245, 1);
          letter-spacing: 1px;
        }
        .el-input__suffix {
          position: absolute;
          top: -5px;
          height: 40px;
        }
      }
    }
    /* 表格部分 */
    .table {
      min-height: 0px;
      .el-table {
        border-radius: 8px 8px 0px 0px;
        .hover-row {
          td {
            padding: 0px;
            background: #fff;
          }
        }
        .cell {
          padding-left: 16px;
          color: #606266;
          font-weight: 400;
          line-height: 16px;
          font-size: 14px;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          .el-input {
            .el-input__inner {
              height: 24px;
              padding: 0 0 0 5px;
            }
          }
        }
        .el-button {
          height: 24px;
          padding: 0px;
          line-height: 24px;
          font-size: 12px;
          span {
            letter-spacing: 1px;
          }
        }
        /* 头部设置 */
        .el-table__header-wrapper {
          tr {
            border-radius: 8px 8px 0px 0px;
            opacity: 0.75;
            th {
              background: #eaeef5;
              min-height: 32px;
              padding: 0;
            }
          }
        }
        /* 身体部分 */
        .el-table__body-wrapper {
          .el-table__body {
            tr {
              td {
                min-height: 30px;
                padding: 0;
                .cell {
                  min-height: 30px;
                  color: #606266;
                  line-height: 16px;
                  padding: 8px 16px;
                  font-size: 14px;
                  .text {
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  /* 物流/其他 */
  .logistics-other {
    .logistics-other-container {
      .el-form {
        font-size: 14px;
        .el-form-item {
          margin-bottom: 20px;
          .el-form-item__label {
            line-height: 32px;
          }
          .el-form-item__content {
            line-height: 64px;
            .el-radio-group {
              height: 80px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .el-radio {
                line-height: 32px;
                display: flex;
                align-items: center;
                .el-radio__label {
                  display: flex;
                  align-items: center;
                  color: #606266;
                  .elInput {
                    margin: 0 6px 0 14px;
                    .el-input__inner {
                      height: 32px;
                      line-height: 32px;
                      width: 96px;
                      background: rgba(234, 238, 245, 0.2);
                      border-radius: 4px;
                      border: 1px solid rgba(234, 238, 245, 1);
                    }
                  }
                  .el-select {
                    position: relative;
                    .el-input__inner {
                      width: 120px;
                      height: 32px;
                      line-height: 32px;
                      padding: 0 20px 0 10px;
                      background: rgba(234, 238, 245, 0.2);
                      border-radius: 4px;
                      border: 1px solid rgba(234, 238, 245, 1);
                    }
                    .el-input__suffix {
                      position: absolute;
                      top: -3px;
                      height: 40px;
                      right: 0px;
                    }
                  }
                  .el-button {
                    height: 32px;
                    line-height: 0px;
                    margin-left: 6px;
                    span {
                      font-size: 12px;
                      color: #3d74f2;
                    }
                  }
                }
              }
            }
          }
        }
        #formItem {
          .el-form-item__content {
            display: flex;
            align-items: center;
            line-height: 32px;
            font-size: 14px;
            color: #606266;
            span {
              padding-left: 6px;
            }
          }
        }
      }
    }
  }
  .el-dialog {
    .search-parameter {
      display: flex;
      margin-bottom: 16px;
      .el-input {
        width: 240px;
        margin-right: 16px;
      }
    }
    .text {
      font-size: 12px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      .el-button {
        height: 24px;
        font-size: 12px;
      }
    }
    .table {
      padding-bottom: 16px;
      border-bottom: 1px solid #f7f7f7;
      .h24 {
        height: 24px;
        width: 90px;
        .el-input__inner {
          height: 24px;
        }
      }
      .el-checkbox {
        width: 90px;
        line-height: 24px;
        .el-checkbox__label {
          font-size: 12px;
          vertical-align: middle;
          .tips {
            width: 76px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
      }
      .page {
        display: flex;
        justify-content: flex-end;
      }
      .el-table .el-table__header-wrapper .el-table__header tr th .cell {
        font-size: 12px;
      }
      .el-table .el-table__body-wrapper .el-table__body tr td .cell {
        font-size: 12px;
        height: auto;
        line-height: normal;
        .el-input__inner {
          height: 24px;
          width: 100px;
        }
      }
    }
    .dialog-footer-btn {
      display: flex;
      justify-content: center;
      padding-top: 16px;
    }
    .add-client {
      margin-bottom: 16px;
      .el-button {
        height: 24px;
        font-size: 12px;
        width: 72px;
        padding: 0;
      }
    }
    .content {
      .table {
        padding-bottom: 0;
        .el-checkbox {
          width: auto;
        }
      }
      .search-key-tag {
        display: flex;
        margin-bottom: 16px;
        .search-tag {
          margin: 0 16px;
        }
      }
      .pagination-container {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .top-search {
    .el-input.white .el-input__inner {
      border-radius: 0px;
      border: none;
      border-bottom: 1px solid #eee;
    }
  }
}
.el-popover {
  z-index: 10;
  padding: 10px !important;
}
.el-select-dropdown {
  .el-select-dropdown__item {
    position: relative;
    .remove {
      display: none;
      width: 15px;
      height: 15px;
      background: #aaa;
      border-radius: 50%;
      top: 9px;
      right: 4px;
      color: #fff;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      position: absolute;
    }
  }
  .el-select-dropdown__item:hover {
    .remove {
      display: inline-block;
    }
  }
}

</style>
